import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus, SilentRequest } from '@azure/msal-browser';
import { catchError, filter, map, Observable, of, switchMap } from 'rxjs';

/**
 * Checks if current user is already logged in.
 * 
 * @param msalService MSAL service.
 * @param msalBroadcastService MSAL event broker service.
 * @returns True when user is already logged in, otherwise - false.
 */
export function checkLogin(msalService: MsalService, msalBroadcastService: MsalBroadcastService): Observable<boolean> {
  return msalBroadcastService.inProgress$.pipe(
    filter(status => status === InteractionStatus.None),
    switchMap(_ => msalService.acquireTokenSilent({} as SilentRequest)),
    map(result => !!result),
    catchError(_ => of(false))
  );
}
